export default function CultureHero() {
  return (
    <section className="relative h-[70vh] min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/assets/CultureHero.jpg"
          alt="Our Work Culture"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center text-white">
        <div className="inline-block bg-white/20 backdrop-blur-sm text-white px-5 py-2 rounded-full text-sm font-semibold mb-6">
          OUR WORK CULTURE
        </div>
        <h1 className="text-6xl md:text-7xl font-bold mb-6 leading-tight">
          Where Excellence Meets Innovation
        </h1>
        <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed">
          We foster a culture of innovation, quality, collaboration, and courage that empowers our team to deliver exceptional pharmaceutical solutions and make a meaningful impact on global healthcare.
        </p>
      </div>
    </section>
  );
}
